export default __webpack_public_path__ + "static/media/vDai.ace4377c.svg";